module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--hexagon",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "hexagon-container"
  }, [_c('li', {
    staticClass: "hexagon hex_1"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_2"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_3"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_4"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_5"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_6"
  }), _vm._v(" "), _c('li', {
    staticClass: "hexagon hex_7"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-098de55e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Hexagon.vue
// module id = 893
// module chunks = 170